// PROVIDER_FINDER_BASE_URL and AUTHORIZER_DOMAIN aren't used here anymore
// but other modules still type against the global window.env shape.
declare global {
  interface Window {
    env: {
      BRIDGE_PUBLISHABLE_KEY?: string
      BRIDGE_ENVIRONMENT?: "sandbox" | "production"
      PROVIDER_FINDER_BASE_URL: string
      AUTHORIZER_DOMAIN: string
      COMPANY_IDS_WITH_TIERED_PROVIDER_NETWORK: number[]
      CARROT_BACKEND_URL: string
      CARROT_PUBLIC_BACKEND_URL: string
    }
  }
}

const Settings = {
  COMPANY_IDS_WITH_TIERED_PROVIDER_NETWORK: window.env?.COMPANY_IDS_WITH_TIERED_PROVIDER_NETWORK,
  CARROT_BACKEND_URL: window.env?.CARROT_BACKEND_URL
} as const

export default Settings
